import React from 'react';

import { SUPPORTED_CHAIN_IDS } from '@/constants/chain';

import { buttons } from '../../../styles/buttons';
import { fontStyles } from '../../../styles/typography';
import { routes } from '../../../utils/routes';

export const GetToKnowHeroSection = () => (
  <section className="tablet:bg-[top_-56px_center] mt-24 flex flex-col items-center bg-[url('/images/about-us/hero-art.svg')] bg-center bg-no-repeat pt-[152px] pr-16 pb-24 pl-16 text-center">
    <span
      className={fontStyles({
        variant: 'H2',
        class:
          'text-primitive-green-800 bg-gradient-to-r from-[rgba(2,168,99,1)] via-[rgba(2,168,99,0.49)] to-[rgba(118,182,36,1)] bg-clip-text text-center text-[20px] leading-[3.5rem] font-bold',
      })}
      style={{
        WebkitTextFillColor: 'transparent',
        background:
          'linear-gradient(rgba(2, 168, 99, 1), rgba(2, 168, 99, 0.49)), linear-gradient(rgba(118, 182, 36, 1), rgba(36, 182, 77, 0))',
        backgroundClip: 'text',
      }}
    >
      DEX aggregator by 0x
    </span>
    <h1
      className={fontStyles({
        variant: 'H1',
        class:
          'tablet:text-[4rem] tablet:leading-[78px] mb-6 grid text-center text-[2.875rem] leading-12',
      })}
    >
      Get to know Matcha
    </h1>
    <div
      className={fontStyles({
        variant: 'BODY_LG',
        class: 'text-token-gray-1000 mb-12 grid max-w-[31rem] text-center',
      })}
    >
      Matcha is the ultimate DEX with over 9 million tokens across {SUPPORTED_CHAIN_IDS.length}{' '}
      chains, matching you with the deepest liquidity in crypto.
    </div>
    <div>
      <a
        className={buttons({ size: 'medium', color: 'black', shape: 'pill' })}
        href={`${routes.ZEROEX_HOME}careers`}
        target="_blank"
      >
        Go to 0x careers
      </a>
    </div>
  </section>
);
